import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../button/button';
import { Dialog } from '../dialog/dialog';
import { FileManager } from '../file-manager/file-manager';
import { FileManagerOptionsState } from '../file-manager/state/file-manager-options-state';

type Props = {
  onClose: () => void;
  defaultFileUploadExtensions?: Readonly<string[]>;
};

const FileManagerDialog = (props: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog contentPadding={false} height={'75%'} width={1200} onClose={props.onClose}>
      {{
        header: t('menu.fileManager.title', { ns: 'navigation' }),
        content: (
          <FileManagerOptionsState defaultFileUploadExtensions={props.defaultFileUploadExtensions}>
            <FileManager />
          </FileManagerOptionsState>
        ),
        footer: {
          right: (
            <>
              <Button variant="text" onClick={props.onClose}>
                {t('close', { ns: 'common' })}
              </Button>
            </>
          ),
        },
      }}
    </Dialog>
  );
};

export { FileManagerDialog, Props as FileManagerDialogProps };
